"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var messageActions = require("@caddigital/sok-reducers/lib/actions/bid/message");
var bidMessageAttachments_1 = require("actions/bidMessageAttachments");
var translate_1 = require("utils/translate");
var download_1 = require("utils/download");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        token: state.auth.current.token,
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(bidMessageAttachments_1.default.toggleModalStatus()); },
    removeFiles: function (files) {
        return dispatch(messageActions.removeFiles(files));
    },
    downloadFiles: function (files, token) { return function () {
        if (files.length > 1 ||
            files.filter(function (f) { return f.type === 'FOLDER'; }).length > 0) {
            var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0));
            var uuid_1 = retVal.payload.uuid;
            (0, download_1.downloadFiles)(token, files, undefined, undefined, function () { return dispatch(ToastActions.removeToast(uuid_1)); }, { includeSubFolders: 'true', includeSelf: 'true' });
            return;
        }
        window.open(__UPLOADSERVERURL__ + '/files/' + files[0].uuid, '_blank');
    }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BidMessageTools'), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.Tools = enhance(function (props) { return (React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'bid-message-view-tools-container' },
    React.createElement(sok_ui_1.ToolsSidebar, { headerText: (0, translation_1.getLocalization)('bid/messagesView/tools/header') },
        React.createElement(sok_ui_1.ToolButton, { color: 'green', text: (0, translation_1.getLocalization)('bid/messageView/upload'), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }), onClick: props.toggleModal, disabled: props.viewMode }),
        props.viewMode && props.selected.length > 0 && (React.createElement(sok_ui_1.ToolButton, { color: 'blue', text: (0, translation_1.getLocalization)('bid/messageView/download'), onClick: props.downloadFiles(props.selected, props.token), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-cloud-download' }) })),
        !props.viewMode && props.selected.length > 0 && (React.createElement(sok_ui_1.ToolButton, { color: 'red', text: (0, translation_1.getLocalization)('bid/messageView/remove'), onClick: function () {
                props.removeFiles(props.selected);
                props.setSelected([]);
            }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-trash' }) }))))); });
